import { ERROR, LOADING, SUCCESS, SIM_SUCCESS } from './MonteCarloActions';

const INITIAL_STATE = {
  isLoading: true,
  success: false,
  error: '',
  data: [],
  simData: [],
  noData: false,
};

const MonteCarloReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ERROR: {
      return { ...state, error: action.error };
    }
    case LOADING: {
      return { ...state, isLoading: action.isLoading };
    }
    case SUCCESS: {
      return { ...state, isLoading: false, data: action.data };
    }
    case SIM_SUCCESS: {
      return { ...state, simData: action.data, noData: !action.data.length };
    }
    default:
      return state;
  }
};

export default MonteCarloReducer;
